module.exports = __webpack_public_path__ + "static/bnr-google-play-d3b196e6455405dd8ccb1fae86378e8c.svg";